import { DialogRef } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';
import { AbstractComponent } from '../abstract.component';

@Component({
  template: '',
})
export abstract class AbstractDialogComponent<R> extends AbstractComponent {
  protected readonly _dialogRef: DialogRef<R> = inject<DialogRef<R>>(DialogRef);

  public close(result?: R): void {
    this._dialogRef.close(result);
  }
}
